import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, MessageSquareQuote, FolderKanban, Sofa, Inbox, LogOut, ExternalLink, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/content", label: "Content", icon: FileText },
  { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquareQuote },
  { to: "/admin/projects", label: "Projects", icon: FolderKanban },
  { to: "/admin/products", label: "Products", icon: Sofa },
  { to: "/admin/inquiries", label: "Inquiries", icon: Inbox },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen bg-[#F6F5F2] flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#2C2A29] text-[#FFFFFF] flex flex-col fixed h-screen">
        <div className="p-6 border-b border-[#5E5A54]/40">
          <Link to="/" className="font-display text-2xl font-semibold">Afurnix</Link>
          <p className="label-eyebrow text-[9px] text-[#9E8773] mt-1">Admin Console</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm font-light transition-colors ${
                  isActive ? "bg-[#9E8773] text-[#FFFFFF]" : "text-[#C9C2B6] hover:bg-[#3A3733]"
                }`
              }
            >
              <l.icon size={18} strokeWidth={1.6} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#5E5A54]/40 space-y-2">
          <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 text-sm text-[#C9C2B6] hover:text-[#FFFFFF] font-light">
            <ExternalLink size={16} /> View site
          </a>
          <Button onClick={handleLogout} variant="ghost" className="w-full justify-start gap-2 text-[#C9C2B6] hover:text-[#FFFFFF] hover:bg-[#3A3733] rounded-none px-4" data-testid="admin-logout">
            <LogOut size={16} /> Sign out
          </Button>
        </div>
      </aside>
      <div className="flex-1 ml-64 p-8 sm:p-12">
        <Outlet />
      </div>
    </div>
  );
}
